function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute(
    'aria-expanded',
    summary.parentNode.hasAttribute('open')
  );

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute(
      'aria-expanded',
      !event.currentTarget.closest('details')?.hasAttribute('open')
    );
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + 'pauseVideo' + '","args":""}',
      '*'
    );
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll('button').forEach((button) => {
      if (!button.classList.contains('localization-selector')) {
        button.addEventListener('click', this.onCloseButtonClick.bind(this));
      }
    });
    this.querySelector('#mn_overlay').addEventListener(
      'click',
      this.closeMenuDrawer.bind(this)
    );
    this.querySelector('#second_close').addEventListener(
      'click',
      this.closeMenuDrawer.bind(this)
    );

    this.querySelectorAll('.subcollection__menu a').forEach((submenuLink) => {
      submenuLink.addEventListener('click', this.closeMenuDrawer.bind(this));
    });
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector('summary')
        )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector('button')
      );
      summaryElement.nextElementSibling.removeEventListener(
        'transitionend',
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty(
          '--viewport-height',
          `${window.innerHeight}px`
        );
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
              'transitionend',
              addTrapFocus
            );
      }, 200);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }, 200);
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.querySelector('#mn_overlay').classList.remove('menu-open');
    this.mainDetailsToggle
      .querySelectorAll('.submenu-open')
      .forEach((submenu) => {
        submenu.classList.remove('submenu-open');
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute('open') &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement
      .querySelector('summary')
      .setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(
            detailsElement.closest('details[open]'),
            detailsElement.querySelector('summary')
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById('shopify-section-header');
    this.borderOffset =
      this.borderOffset ||
      this.closest('.header-wrapper').classList.contains(
        'header-wrapper--border-bottom'
      )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    }, 200);

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
    this.querySelector('#mn_overlay').classList.add('menu-open');
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

// Menu

document.querySelectorAll('.first-level-menu.has-child').forEach((element) => {
  if (window.innerWidth < 749) {
    if (element.lastElementChild)
      element.lastElementChild.style.display = 'none';
    return;
  }
  element.addEventListener('mouseover', () => {
    element.classList.add('hover');
    if (element.lastElementChild)
      element.lastElementChild.style.visibility = 'visible';
    document.getElementById('root')?.classList.add('over-hover-menu');
  });
  element.addEventListener('mouseout', () => {
    element.classList.remove('hover');
    document.getElementById('root')?.classList.remove('over-hover-menu');
  });
});

document.querySelectorAll('.subcollection_item a').forEach((el) => {
  el.addEventListener('mouseover', () => {
    document
      .querySelectorAll('.submenu_product_list')
      .forEach((productList) => {
        if (
          el?.parentElement?.dataset.name ==
          productList.dataset.parentCollection
        ) {
          productList.classList.remove('hidden');
          document
            .querySelector(
              `.subcollection_item[data-name='${productList?.dataset.parentCollection}']`
            )
            ?.classList.add('subcollection__item--active');
        } else {
          productList.classList.add('hidden');
          document
            .querySelector(
              `.subcollection_item[data-name='${productList?.dataset.parentCollection}']`
            )
            ?.classList.remove('subcollection__item--active');
        }
      });
  });
});

document.querySelectorAll('.subcollection_item_link').forEach((subCollLink) => {
  subCollLink.addEventListener('click', function () {
    subCollLink
      ?.closest('.first-level-menu.has-child')
      ?.classList.remove('hover');
    if (subCollLink && subCollLink.closest('.submenu')) {
      subCollLink.closest('.submenu').style.visibility = 'hidden';
    }
    document.getElementById('root')?.classList.remove('over-hover-menu');
  });
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]')?.addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (
          event.pointerType === 'mouse' &&
          !event.target.closest('deferred-media, product-model')
        )
          this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class PopupRedirect extends ModalDialog {
  constructor() {
    super();
    this.popupHeadingElm = this.querySelector('.heading');
    this.thisStoreHandle = redirectData.this_store.handle;
    this.popupTextContentElm = this.querySelector(
      '.country-redirect__text-content'
    );
    this.popupRecommendedCountryFlagElm = this.querySelector(
      '.country-redirect__flag'
    );
    this.popupRecommendedCountryNameElm = this.querySelector(
      '.country-redirect__url-label'
    );
    this.id = this.getAttribute('id');
    this.popupRecommendedStoreUrlLabel = this.querySelector(
      '.country-redirect__recommended-store-url'
    );
    this.popupRecommendedUrl = this.querySelector('.country-redirect__url');
    if (sessionStorage.getItem(this.id) == 'true') {
      return;
    } else if (sessionStorage.getItem(this.id) == null) {
      this.fetchBrowserContextSuggestions();
    }
    let contextData;
    let currentCountryHandle;
    let currentCountryName;
    let storeId;
  }

  fetchBrowserContextSuggestions() {
    const url = location.origin + '/browsing_context_suggestions.json';
    fetch(url)
      .then((response) => response.json())
      .then((data) => {
        this.contextData = data.detected_values;
        this.currentCountryHandle = this.contextData.country.handle;
        this.currentCountryName = this.contextData.country_name;
        this.checkRedirectOption(this.currentCountryHandle);
        this.storeId =
          redirectData.countries_storeId[
            this.currentCountryHandle.toUpperCase()
          ];
      })
      .then(() => {
        window.onload = (t) => {
          if (redirectData.stores[this.storeId] == shopUrl) return;

          if (
            redirectData.stores[this.storeId] == undefined &&
            this.thisStoreHandle == 'com'
          )
            return;

          this.setAttribute('open', '');
          sessionStorage.setItem(this.id, 'true');
        };
      });
  }

  checkRedirectOption(handle) {
    const currentStore = location.origin;
    const storeId = redirectData.countries_storeId[handle];
    const recommendedStore = redirectData.stores[storeId];
    if (storeId != undefined && currentStore == recommendedStore) return;
    if (storeId != undefined && currentStore != recommendedStore) {
      this.getRecommendedCountryData(storeId);
    }
    if (storeId == undefined) {
      this.getRecommendedCountryData('COM');
    }
  }

  getFlagUrl(countryCode) {
    return `https://cdn.shopify.com/static/images/flags/${countryCode}.svg`;
  }

  getRecommendedCountryData(handle) {
    let currentCountry = this.currentCountryHandle.toLowerCase();
    let flagUrl = this.getFlagUrl(currentCountry);
    if (handle == 'COM') {
      this.popupRecommendedCountryFlagElm.innerHTML = `
        <img src='${flagUrl}' alt='${currentCountry} flag'></img>
      `;
      this.popupRecommendedCountryNameElm.innerHTML =
        redirectData.popup_content[handle].country_name[currentCountry];
    }
    if (handle != 'COM') {
      this.popupRecommendedCountryFlagElm.innerHTML = `
        <img src='${redirectData.popup_content[handle].flag}'></img>
      `;
      this.popupRecommendedCountryNameElm.innerHTML =
        redirectData.popup_content[handle].country_name[currentCountry];
    }
    this.popupHeadingElm.innerHTML = redirectData.popup_content[handle].heading;
    this.popupTextContentElm.innerHTML =
      redirectData.popup_content[handle].content;
    this.popupRecommendedStoreUrlLabel.innerHTML =
      redirectData.popup_content[handle].label;
    this.popupRecommendedUrl.setAttribute('href', redirectData.stores[handle]);
  }
}

customElements.define('popup-redirect', PopupRedirect);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(
        this.querySelector('template').content.firstElementChild.cloneNode(true)
      );

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(
        content.querySelector('video, model-viewer, iframe')
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

const observeDOM = (function () {
  const MutationObserver =
    window.MutationObserver || window.WebKitMutationObserver;

  return function (obj, callback) {
    if (!obj || obj.nodeType !== 1) return;

    if (MutationObserver) {
      var mutationObserver = new MutationObserver(callback);
      mutationObserver.observe(obj, { childList: true, subtree: true });
      return mutationObserver;
    } else if (window.addEventListener) {
      obj.addEventListener('DOMNodeInserted', callback, false);
      obj.addEventListener('DOMNodeRemoved', callback, false);
    }
  };
})();

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.componentId = this.id;
    this.sectionId = this.dataset.sectionId;
    this.paginationIcon = this.querySelector('.swiper-pagination-icon .icon');
    this.init();
    window.addEventListener('resize', debounce(this.init.bind(this), 500));
    document.addEventListener('shopify:section:load', this.init.bind(this));
  }

  init() {
    let enableSlider;
    this.paginationType = this.dataset.paginationType;
    if (this.dataset.slider) {
      enableSlider = JSON.parse(this.dataset.slider);
    }
    if (enableSlider && !this.dataset.sliderMobile) {
      this.initSlider();
    }
    if (enableSlider && this.dataset.sliderMobile == 'false') {      
      if (window.innerWidth >= 750) {
        this.initSlider();
      } else {
        this.slider?.destroy();
      }
    }
  }

  initSlider() {
    this.slider = new Swiper(`.swiper-${this.componentId}`, {
      slidesPerView: this.dataset.slidesPerViewMobile,
      direction: this.dataset.direction,
      spaceBetween: this.dataset.spaceBetweenMobile || 15,
      loop: this.dataset.loop == 'true' ? true : false,
      speed: 500,
      zoom: this.dataset.zoom == 'true' ? true : false,
      centeredSlides: this.dataset.centeredSlidesMobile == 'true' ? true : false,
      initialSlide: this.dataset.centeredSlidesMobile == 'true' ? 1 : 0, 
      pagination: {
        el: `.swiper-pagination-${this.componentId}`,
        clickable: true,
        type: this.paginationType || 'bullets',
        renderBullet: function (index, className) {
          return `
            <span class="${className}"> 
              <svg width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M1.57532 1.06738L6.85982 6.35188L1.27988 11.9318" stroke="#393939" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
              </svg>
            </span>
          `;
        },
        renderProgressbar: function (progressbarFillClass) {
          return `<span class="${progressbarFillClass}"></span>`;
        },
        renderFraction: function (currentClass, totalClass) {
          return `<span class="${currentClass}"></span>/<span class="${totalClass}"></span>`;
        },
      },
      navigation: {
        nextEl: `.swiper-next-button-${this.componentId}`,
        prevEl: `.swiper-prev-button-${this.componentId}`,
      },
      scrollbar: {
        el: `.swiper-scrollbar-${this.componentId}`,
        draggable: true,
      },
      thumbs: {
        swiper:
          this.nextElementSibling != null && this.nextElementSibling.classList.contains('thumbnails')
            ? this.nextElementSibling
            : '',
      },
      mousewheel: this.classList.contains('thumbnails') ? true : false,
      breakpoints: {
        750: {
          slidesPerView: this.dataset.slidesPerViewDesktop,
          spaceBetween: this.dataset.spaceBetweenDesktop || 15,
          centeredSlides: this.dataset.centeredSlidesDesktop == 'true' ? true : false,
          initialSlide: this.dataset.centeredSlidesDesktop == 'true' ? 1 : 0,
          autoplay:
            this.dataset.autoplayDesktop == 'true'
              ? {
                  delay: parseInt(this.dataset.autoplaySpeedDesktop),
                  disableOnInteraction: true,
                  pauseOnMouseEnter: true,
                }
              : false,
        },
      },
      autoplay:
        this.dataset.autoplayMobile == 'true'
          ? {
              delay: parseInt(this.dataset.autoplaySpeedMobile),
              disableOnInteraction: true,
              pauseOnMouseEnter: true,
            }
          : false,
    });
    let swiper = document.querySelector(`.swiper-${this.componentId}`)?.swiper;
    let componentId = this.componentId;

    if (swiper.el.classList.contains('swiper-video-list')) {
      if (swiper.slides) {
        swiper.slides.forEach((slide) => {
          let slideWidth = slide.offsetWidth;
          let slideHeight = slideWidth * 1.7745;
          slide.style.height = slideHeight + 'px';
        });
      }
    }

    if (document.querySelector(`.gallery-progress-bar-${this.sectionId}`)) {
    document.querySelectorAll('.gallery-progress-bar__section')[0].classList.add('active');
    }
    
    if (swiper) {
      swiper.on('slideChangeTransitionStart', () => {
        // remove color of ::selection
        // bug of swiper that randomly trigger ::selection color of an element, not fixed yet, this is a workaround
        document.body.classList.add('selection--transparent');

        // get all unhidden images 
        if (!document.querySelector(`.gallery-progress-bar-${this.sectionId}`)) return;
        let unhiddenSlides = swiper.slides.filter((slide) => !slide.classList.contains('hidden'));
        let currentSlideIndex = swiper.activeIndex;
        document.querySelectorAll('.gallery-progress-bar__section').forEach((section) => {
          section.classList.remove('active');
        });
        document.querySelector(`[data-media-index="${currentSlideIndex}"]`).classList.add('active');
          
      });

      swiper.on('slideChangeTransitionEnd', () => {
        setTimeout(() => {
          document.body.classList.remove('selection--transparent');
        }, 1000);
      });

      swiper.on('reachEnd', function () {
        document.body.classList.add('selection--transparent');
        let prevBtn = document.querySelector(`.swiper-prev-button-${componentId}`);
        if (!prevBtn) return;
        prevBtn.addEventListener('click', goToFirstSlide);
      });

      swiper.on('reachBeginning', function () {
        document.body.classList.add('selection--transparent');
        let prevBtn = document.querySelector(`.swiper-prev-button-${componentId}`);
        if (!prevBtn) return;
        prevBtn.removeEventListener('click', goToFirstSlide);
      });

      function goToFirstSlide() {
        swiper.slideTo(0);
      }
    }

    if (this.dataset.enableControls == 'false') return;    
    let slidesPerView = Math.floor(parseFloat(this.slider?.params?.slidesPerView));
    let firstSlide = this.slider?.slides?.length > 0 ? this.slider?.slides[0] : undefined;
    if (!firstSlide) return;
    let slideWidth = firstSlide.offsetWidth + parseInt(this.slider.params.spaceBetween);
    let slider = document.getElementById(this.componentId);
    let paginationGroup = document.querySelector(`.swiper-pagination__group-${this.sectionId}`);
    let sliderPaddingLeft = parseFloat(
              getComputedStyle(slider).paddingLeft.replace('px', '')
            );
    let cardInner = firstSlide.querySelector('.card__inner') || document.getElementById(this.componentId);
    let nextBtnPosition = (slideWidth * slidesPerView) - parseInt(this.slider.params.spaceBetween) - sliderPaddingLeft;
    if (slider.classList.contains('swiper-video-list')) {
      nextBtnPosition = (slideWidth * slidesPerView) - parseInt(this.slider.params.spaceBetween) - 30;
    }
    
    let nextBtn = document.querySelector(`.swiper-next-button-${this.componentId}`);
    let nextBtnHeight = nextBtn.offsetHeight;
    let cardInnerHeight = cardInner.offsetHeight - nextBtnHeight;
    if (nextBtn && Math.floor(swiper.params.slidesPerView) != 1) nextBtn.style.left = `${nextBtnPosition}px`;
    if (paginationGroup) paginationGroup.style.top = `${cardInnerHeight / 2}px`;
  }
}
customElements.define('slider-component', SliderComponent);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
    this.selectedVariant = this.querySelector('input:checked');
    this.subscriptionInput = document.querySelector(
      'input[id="subscription_plan"]'
    );
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    if (!this.classList.contains('video-variant-radios')) this.toggleAddButton(true, '', false);
    this.removeErrorMessage();
    this.updateVariantTitle();
    this.initPrevButton();
    this.updateStickyBarImage();

    if (this.currentVariant) {
      this.updateVariantInput();
      this.renderProductInfo();
      if (location.pathname.includes('/products/')) this.updateURL();
      this.updateMedia();
    } else {
      if (!this.classList.contains('video-variant-radios')) this.toggleAddButton(true, '', true);
      this.setUnavailable();
    }

    if (window.innerWidth < 990) {
      this.updateMediaProgressBar();
    }
    this.hideShowVariants();

  }

  hideShowVariants() {
    const variantSelects = document.querySelector('variant-radios');
    const fieldsets = Array.from(variantSelects.querySelectorAll('fieldset'));
    
    this.productJson = JSON.parse(variantSelects.querySelector('[type="application/json"]').textContent);
    this.selectedOptions = [];
    this.selectedOptions = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value
    });
    
    for(let optionLevel = 1, n = fieldsets.length; optionLevel < n; optionLevel++) {
      const inputs = fieldsets[optionLevel].querySelectorAll('input');
      
      inputs.forEach(input => {
        input.disabled = (this.validCombo(input.value,optionLevel)) ? false : true;
      });
    }
    
    for (let optionLevel = 1, fieldsetsLength = fieldsets.length, change = false; optionLevel < fieldsetsLength && !change; optionLevel++) {
      if(fieldsets[optionLevel].querySelector('input:checked').disabled === true) {
        change = (fieldsets[optionLevel].querySelector('input:not(:disabled)').checked = true);
      }
      if(change) variantSelects.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  validCombo(inputValue, optionLevel) {
    for(let i = 0; i < this.productJson.length; i++) {
      if(optionLevel == 1){
        if (this.productJson[i].option1 == this.selectedOptions[0] && this.productJson[i].option2 == inputValue) {  return true; }
      } else {
        if (this.productJson[i].option1 == this.selectedOptions[0] && this.productJson[i].option2 == this.selectedOptions[1] && this.productJson[i].option3 == inputValue) {  return true; }
      }
    }
  }

  initPrevButton() {
    // make sure it's hidden on variant change
    let productSection = this.closest('.product');
    let prevButton = productSection?.querySelector('.slider-button--prev');
    prevButton?.classList.add('hidden');
  }

  updateMediaProgressBar() {
    // mobile only
    let variantMediaInfo = document.getElementById(
      `variantMediaInfo-${this.currentVariant.id}`
    );
    const variantMediaSize = parseInt(
        variantMediaInfo?.dataset.variantMediaSize
      ),
      galleryProgressBar = document.querySelector('.gallery-progress-bar');

    if (galleryProgressBar == undefined) {
      return;
    }
    galleryProgressBar?.setAttribute('data-media-size', variantMediaSize);
    galleryProgressBar.innerHTML = '';

    if (variantMediaSize < 2) {
      galleryProgressBar.classList.add('invisible');
    } else {
      galleryProgressBar.classList.remove('invisible');
    }

    for (let item = 0; item < variantMediaSize; item++) {
      let progressBarSection = document.createElement('span');
      progressBarSection.classList.add('gallery-progress-bar__section');
      progressBarSection.setAttribute('data-media-index', item + 1);
      let width = 100 / variantMediaSize;
      progressBarSection.style.width = width + '%';
      galleryProgressBar.appendChild(progressBarSection);
    }
  }

  updateVariantTitle() {
    let currentVariantStickFormTitle =
      document.querySelector('.stick-info__title');
    if (
      currentVariantStickFormTitle != undefined ||
      currentVariantStickFormTitle != null
    ) {
      currentVariantStickFormTitle.innerText = this.currentVariant?.title;
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll('select'),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateStickyBarImage() {
    let elmImage = document.querySelector('.stick-image__container');
    if (elmImage) {
      let currentVariantImageSrc =
        window.variantsImages[this.currentVariant?.id];
      elmImage.style.backgroundImage = `url(${currentVariantImageSrc})`;
    }
  }

  updateMedia() {
    if (!this.currentVariant) return;

    const mediaGalleries = document.querySelectorAll(
      `[id^="MediaGallery-${this.dataset.section}"]`
    );

    const productId = this.dataset.productId;

    let thisVariantHasOwnGallery = false;
    
    let thisVariantInput = this.querySelector(
      `input[data-variant-id="${this.currentVariant?.id}"]`
    );
    if (thisVariantInput?.dataset.variantImages == 'true') {
      thisVariantHasOwnGallery = true;
    }

    mediaGalleries.forEach((mediaGallery) => {
      if (window.request.page_type == 'product') {
        if (this.currentVariant.featured_media) {
          mediaGallery.setActiveMedia(
            `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
            true
          );
        }
      }
      // let mediaItems = mediaGallery.querySelectorAll('.product__media-item');
      // if variant has its own gallery in variant metafields, hide other images
      // if (mediaItems.length == 0) return;
      // imagesToShow(
      //   thisVariantHasOwnGallery,
      //   mediaItems,
      //   this.currentVariant.id
      // );
    });

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;

    let newMediaModal;

    if (this.currentVariant.featured_media) {
      newMediaModal = modalContent.querySelector(
        `[data-media-id="${this.currentVariant.featured_media.id}"]`
      );
    } else {
      newMediaModal = modalContent.querySelector(
        `[data-image-variant-id="${this.currentVariant.id}"][data-variant-featured-media]`
      );
    }

    if (newMediaModal != null) {
      modalContent.prepend(newMediaModal);
    }

    // update variant image gallery in modal, if variant has its own gallery in variant metafields, hide other images
    let modalMediaItems = modalContent.querySelectorAll('img');
    imagesToShow(
      thisVariantHasOwnGallery,
      modalMediaItems,
      this.currentVariant.id
    );

    function imagesToShow(
      thisVariantHasOwnGallery,
      imageObject,
      currentVariantId
    ) {
      // if variant doesn't have its own gallery, then show the default variant image and default gallery from product admin
      let sliderComponent = imageObject[0].closest('slider-component');
      let nextBtn = sliderComponent?.querySelector('.slider-button--next');
      imageObject.forEach((image) => image.classList.remove('single-media'));
      // update media length
      if (thisVariantHasOwnGallery == true) {
        let imageArray = [];
        imageObject.forEach((media) => {
          if (media.classList.contains('product__media-item--general')) {
            media.classList.add('hidden');
          }
          if (parseInt(media.dataset.imageVariantId) != currentVariantId) {
            media.classList.add('hidden');
          } else {
            media.classList.remove('hidden');
          }
          if (media.classList.contains('hidden') == false) {
            imageArray.push(media);
          }
        });

        // if there's only 1 image showing, make it full width of container
        if (imageArray.length == 1) {
          imageArray[0].classList.add('single-media');
          if (nextBtn != undefined) {
            nextBtn.style.visibility = 'hidden';
          }
        } else {
          if (nextBtn != undefined) {
            nextBtn.style.visibility = 'visible';
          }
        }
      } else {
        // if variant doesn't have its own gallery, then show the default variant image and default gallery from product admin
        let imageArray = [];
        imageObject.forEach((media) => {
          if (media.dataset.imageVariantId) {
            media.classList.add('hidden');
          } else {
            media.classList.remove('hidden');
            imageArray.push(media);
          }
        });
      }
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    let url;
    if (this.subscriptionInput?.checked) {
      let sellingPlanId = this.querySelector(
        `input[data-variant-id="${this.currentVariant.id}"]`
      ).dataset.sellingPlanId;
      url = `${this.dataset.url}?variant=${this.currentVariant.id}&selling_plan=${sellingPlanId}`;
    } else {
      url = `${this.dataset.url}?variant=${this.currentVariant.id}`;
    }
    window.history.replaceState({}, '', url);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(
      `${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}, #product-form-stick`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      if (
        this.querySelector('input:checked').dataset.upsellOtherVariants ==
        'true'
      ) {
        this.querySelector('input:checked').dataset.upsellOtherVariants =
          'true';
        input.dataset.upsellOtherVariants = 'true';
      } else {
        this.querySelector('input:checked').dataset.upsellOtherVariants =
          'false';
        input.dataset.upsellOtherVariants = 'false';
      }
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    const mainProductForm = document.getElementById('dawn-AddToCart');
    const backInStockForm = document.querySelector('.back-in-stock-form');

    if (!this.currentVariant) {
      mainProductForm.classList.add('hidden');
      backInStockForm.classList.remove('hidden');
    } else {
      mainProductForm.classList.remove('hidden');
      backInStockForm.classList.add('hidden');
    }
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const activeElementId = document.activeElement.id;
    let fetchUrl;
    let fetchUrlQuickAdd;

    if (this.subscriptionInput?.checked) {
      let sellingPlanId = this.querySelector(
        `input[data-variant-id="${this.currentVariant.id}"]`
      )?.dataset.sellingPlanId;

      fetchUrl = `${this.dataset.url}?variant=${
        this.currentVariant.id
      }&selling_plan=${sellingPlanId}&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`;
      fetchUrlQuickAdd = `${this.dataset.url}?variant=${this.currentVariant.id}&selling_plan=${sellingPlanId}&section_id=sticky-quick-add`;
    } else {
      fetchUrl = `${this.dataset.url}?variant=${
        this.currentVariant.id
      }&section_id=${
        this.dataset.originalSection
          ? this.dataset.originalSection
          : this.dataset.section
      }`;
      fetchUrlQuickAdd = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=sticky-quick-add`;
    }
    fetch(fetchUrl)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        let productInfoDestination = document.getElementById(
          `ProductInfo-${this.dataset.section}`
        );
        const productInfoSource = html.getElementById(
          `ProductInfo-${
            this.dataset.originalSection
              ? this.dataset.originalSection
              : this.dataset.section
          }`
        );

        let productMediaGalleryDestination = document.querySelector('media-gallery')
        const productMediaGallerySource = html.querySelector('media-gallery')

        if (productInfoDestination == null) {
          productInfoDestination = document.getElementById(
            `ProductInfo-quickadd-${this.dataset.section}`
          );
        }

        if (productInfoSource && productInfoDestination) {
          productInfoDestination.innerHTML = productInfoSource.innerHTML;
        }

        if (productMediaGalleryDestination && productMediaGallerySource) 
          productMediaGalleryDestination.innerHTML = productMediaGallerySource.innerHTML;


        let videoProductModalDestination = document.querySelector('.video-product-modal__content');
        let videoProductModalSource = html.querySelector('.video-product-modal__content');

        if (videoProductModalDestination && videoProductModalSource) {
          videoProductModalDestination.innerHTML = videoProductModalSource.innerHTML;
        }        
        
        document
          .querySelectorAll('variant-radios')?.forEach((variantRadio) => {
            variantRadio.classList.remove('is-loading')
          });
      });

    fetch(fetchUrlQuickAdd)
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`sticky-quick-add`);
        const source = html.getElementById(`sticky-quick-add`);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
        }
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-stick`
    );

    productForms.forEach((productForm) => {
      if (!productForm) return;
      const addButton = productForm.querySelector('[name="add"]');
      const backInStockButtons = document.querySelectorAll(
        '.back-in-stock-form'
      );
      const addButtonTextBlock = productForm.querySelector(
        '.add-to-cart-btn__text-block'
      );
      const addButtonText = productForm.querySelector('.add-to-cart-text');
      if (!addButton) return;

      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
        // addButton.classList.add('hidden');
        backInStockButtons.forEach((btn) => {
          btn.classList.remove('hidden');
        });
        // update variantID for Klaviyo back in stock form
        
        document.querySelector('.bis-submit-btn').dataset.variantId =
          this.currentVariant?.id;
      } else {
        addButton.classList.remove('hidden');
        backInStockButtons.forEach((btn) => {
          btn.classList.add('hidden');
        });
        addButton.removeAttribute('disabled');

        // check preorder status
        // let variantHasPreorderStatus = JSON.parse(
        //   document.querySelector(
        //     `.product-form__input input[data-variant-id="${this.currentVariant.id}"]`
        //   ).dataset.variantHasPreorderStatus
        // );

        // if (variantHasPreorderStatus) {
        //   addButtonText.textContent = window.variantStrings.preorder;
        // } else {
        //   addButtonText.textContent = window.variantStrings.addToCart;
        // }
      }

      if (!modifyClass) return;
    });
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('.add-to-cart-text');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (
            !this.querySelector('slideshow-component') &&
            this.classList.contains('complementary-products')
          ) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), {
      rootMargin: '0px 0px 400px 0px',
    }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

function cartdrawerFreeShippingNote() {
  let shippingEls = document.querySelectorAll(
    '.minicart_shipping.show-progression-shipping'
  );
  shippingEls.forEach((shippingEl) => updateFreeShippingNote(shippingEl));
}

function updateFreeShippingNote(shippingEl) {
  let titleProcessEl = shippingEl.querySelector('.title--process');
  if (titleProcessEl == undefined) {
    return;
  }
  let titleSuccessEl = shippingEl.querySelector('.title--success');
  let totalLeftEl = shippingEl.querySelector('.total-left');
  let shippingProgressEl = shippingEl.querySelector('.shipping--progress');
  const formatter = new Intl.NumberFormat(Shopify.locale, {
    style: 'currency',
    currency: Shopify.currency.active,
  });
  if (
    parseInt(shippingEl.dataset.shipping) > parseInt(shippingEl.dataset.total)
  ) {
    titleProcessEl.classList.add('active');
    titleSuccessEl.classList.remove('active');
    let totalLeft = `${formatter.format(
      parseInt(shippingEl.dataset.shipping) - parseInt(shippingEl.dataset.total)
    )}`;
    totalLeftEl.innerHTML = totalLeft;
    let storeLocation = window.location.href.split('/')[2].split('.')[2];
    if (
      (totalLeftEl.innerHTML.indexOf(/&nbsp;/g) == -1 &&
        storeLocation == 'si') ||
      (storeLocation == 'sk' && totalLeftEl.innerHTML.indexOf(/&nbsp;/g) == -1)
    ) {
      totalLeftEl.innerHTML = totalLeftEl.innerHTML.replace(/&nbsp;/g, '');
    }
    shippingProgressEl.style.width = `${
      (parseInt(shippingEl.dataset.total) /
        parseInt(shippingEl.dataset.shipping)) *
      100
    }%`;
  } else {
    titleProcessEl.classList.remove('active');
    titleSuccessEl.classList.add('active');
    shippingProgressEl.style.width = '100%';
  }
}
cartdrawerFreeShippingNote();

function upsellAddToCart(el) {
  let data = {
    quantity: 1,
    id: el.dataset.id,
    sections: 'cart-drawer,cart-icon-bubble',
  };
  const config = fetchConfig('javascript');
  config.headers['X-Requested-With'] = 'XMLHttpRequest';
  config.body = JSON.stringify(data);
  config.method = 'POST';
  fetch(Shopify.routes.root + 'cart/add.js', config)
    .then((response) => response.json())
    .then((response) => {
      if (response.status) {
        alert(response.description);
        return;
      }
      document.querySelector('cart-drawer').renderContents(response);
    })
    .catch((e) => {
      console.error(e);
    });
}

let anchors = document.querySelectorAll('.hash-on-page');
let destinations = document.querySelectorAll('.anchor-destination');

anchors.forEach((anchor) => {
  anchor.addEventListener('click', function (e) {
    e.preventDefault();
    let anchorHref = anchor.getAttribute('href');
    let anchorDestination = document.querySelector(this.getAttribute('href'));
    let anchorDestinationId = anchorDestination.getAttribute('id');
    anchorDestination.scrollIntoView({
      block: 'nearest',
    });

    anchors.forEach((anchor) => {
      if (anchor.getAttribute('href') != anchorHref) {
        anchor.classList.remove('anchor--active');
      } else {
        anchor.classList.add('anchor--active');

        // move active logo to the center
        if (window.innerWidth < 500) {
          let sliderExists =
            anchor.parentElement?.parentElement?.classList.contains('slider');
          if (sliderExists) {
            let slider = anchor.parentElement?.parentElement;
            let sliderGap = parseFloat(
              getComputedStyle(slider).columnGap.replace('px', '')
            );
            let anchorWidth = anchor.offsetWidth + sliderGap;
            if (anchor.parentElement.offsetLeft > window.screen.width / 2) {
              anchor.parentElement.parentElement.scrollTo({
                left: anchor.parentElement.offsetLeft - anchorWidth,
                behavior: 'smooth',
              });
            }
          }
        }
      }
    });

    destinations.forEach((destination) => {
      if (destination.getAttribute('id') != anchorDestinationId) {
        destination.classList.remove('slide--active');
      } else {
        destination.classList.add('slide--active');
      }
    });
  });
});

class TabDetails extends HTMLElement {
  constructor() {
    super();
    this.handleTabs();
  }

  handleTabs() {
    let summary = this.querySelector('summary');
    summary.addEventListener('click', () => {
      this.toggleAttribute('open');
    });
  }
}

customElements.define('tab-details', TabDetails);

(() => {
  if (JSON.stringify(window.hiddenVariantsInCart) != '{}') {
    let hiddenVariantsArray = Object.keys(window.hiddenVariantsInCart).map(
      (key) => window.hiddenVariantsInCart[key]
    );

    let updatesBody = {
      updates: {},
    };

    hiddenVariantsArray.forEach((item) => {
      updatesBody.updates[item] = 0;
    });

    (async () => {
      const response = await fetch(
        window.Shopify.routes.root + 'cart/update.js',
        {
          headers: {
            'Content-Type': 'application/json',
          },
          method: 'POST',
          body: JSON.stringify(updatesBody),
        }
      )
        .then((response) => response.json())
        .then((data) => {
          fetch(window.Shopify.routes.root)
            .then((response) => response.text())
            .then((responseText) => {
              const fetchedHtml = new DOMParser().parseFromString(
                responseText,
                'text/html'
              );

              let elements = [
                '.header__text--cart',
                '.item_count',
                'cart-drawer',
              ];

              elements.forEach((element) => {
                let destination = document.querySelector(element);
                let source = fetchedHtml.querySelector(element);
                if (source && destination) {
                  destination.innerHTML = source.innerHTML;
                  if (element == 'cart-drawer') {
                    if (data.items.length == 0) {
                      destination.classList.add('is-empty');
                    }
                  }
                }
              });
            });

          let cartItemsSection = document.querySelector('[id$=cart-items]');
          if (cartItemsSection) {
            return fetch(
              window.Shopify.routes.root +
                `?section_id=${cartItemsSection.id
                  .split('shopify-section-')
                  .pop()}`
            )
              .then((response) => response.text())
              .then((responseText) => {
                const fetchedHtml = new DOMParser().parseFromString(
                  responseText,
                  'text/html'
                );
                const cartDestination = document.querySelector('.main-cart');
                const cartSource = fetchedHtml.querySelector('.main-cart');
                if (cartSource && cartDestination) {
                  cartDestination.innerHTML = cartSource.innerHTML;
                }
              });
          }
        });
    })();
  }
})();


class waitingList extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('.waiting-list-form');
    this.webhook = this.form?.dataset.makeWebhook;
    this.formButton = this.querySelector('button');
    this.form?.addEventListener('submit', this.submitForm.bind(this));
    this.formSuccessMessage = this.querySelector(
      '.newsletter-form__message--success'
    );
    this.formErrorMessage = this.querySelector(
      '.newsletter-form__message--error'
    );
  }

  async submitForm(e) {
    e.preventDefault();
    if (
      this.webhook == undefined ||
      this.webhook == '' ||
      this.webhook == null
    ) {
      return;
    }
    let email = this.form?.querySelector('input[type="email"]')?.value;
    let name = this.form?.querySelector('input[name="first_name"]')?.value;
    let tags = this.form?.querySelector('input[name="tags"]')?.value;
    if (email) {
      let response = await fetch(this.webhook, {
        method: 'POST',
        body: JSON.stringify({ email: email, first_name: name, tags: tags }),
        headers: {
          'Content-type': 'application/json',
        },
      });
      if (response.status == 200) {
        this.formSuccessMessage?.classList.remove('hidden');
      } else {
        this.formErrorMessage?.classList.remove('hidden');
      }
    }
  }
}

customElements.define('waiting-list', waitingList);

class PopupCodes extends ModalDialog {
  constructor() {
    super();
    this.code = this.querySelector('.discount-code');
    this.input = this.querySelector('.discount-code-input');
    this.popupAppearance();

    let input = this.querySelector('.discount-code-input');
    let copyButton = this.querySelector('.discount-code-copy');

    copyButton.addEventListener('click', function() {
      input.select();
      input.setSelectionRange(0, 99999);
      navigator.clipboard.writeText(input.value);
      this.querySelector('.discount-code-copy img').src = copyButton.dataset.copied;
    });
  }

  popupAppearance() {
    const utmParameter = location.href.split('?')[1];
    let currentCombination = window.utm_combinations.combinations.find((el) => el.parameter == utmParameter);
    if (currentCombination) {
      this.code.innerHTML = currentCombination.code;
      this.input.value = currentCombination.code;
      this.setAttribute('open', '');
    }
  }
}

customElements.define('popup-customer-codes', PopupCodes);

class SectionCategoryDescription extends HTMLElement {
  constructor() {
      super();
       let container = this;
       let expandBtn = this.querySelector('.expand-more'); 
       let image = document.querySelector('.collection-hero__image-container-image');
       let descriptionHeigh = document.querySelector('.text-more').scrollHeight;
       if (descriptionHeigh > document.querySelector('.text-more').offsetHeight) {
         expandBtn.classList.remove('hidden');
       }
       if (descriptionHeigh <= document.querySelector('.text-more').offsetHeight) {
          document.querySelector('.text-more').classList.add('f_descr')
       } 
       expandBtn.addEventListener('click', function() {
         let textWrap = container.querySelector('.text-more');
         if (textWrap.classList.contains('expanded')) {
           textWrap.classList.remove('expanded');
           let top = document.querySelector('.collection-hero__text-wrapper').getBoundingClientRect().top;
           window.scrollTo({ top: top, behavior: 'smooth'});
           expandBtn.querySelector('span').innerHTML = `${document.querySelector('.show-less').dataset.textShowMore}`;
           document.querySelector('.collection-hero__image-container').classList.remove('sticky');
           document.querySelector('.collection-hero__text-wrapper').classList.add('collapsed');
           if(window.innerWidth > 990) {
             document.querySelector('.collection-hero__image-container').style.height = document.querySelector('.collection-hero__text-wrapper').offsetHeight + 'px';
             document.querySelector('.collection-hero__image-container').style.maxHeight = document.querySelector('.collection-hero__image-container-img').height + 'px';
           }
         } else {
           textWrap.classList.add('expanded');
           expandBtn.querySelector('span').innerHTML = `${document.querySelector('.show-less').dataset.textShowLess}`;
           document.querySelector('.collection-hero__image-container').classList.add('sticky');
           document.querySelector('.collection-hero__text-wrapper').classList.remove('collapsed');

           if(window.innerWidth > 990) { 
             document.querySelector('.collection-hero__image-container').style.height = document.querySelector('.collection-hero__text-wrapper').offsetHeight + 'px';
             document.querySelector('.collection-hero__image-container').style.maxHeight = document.querySelector('.collection-hero__image-container-img').height + 'px';
           }

         }
       });
  }
}
customElements.define('category-description', SectionCategoryDescription);
